import { render, staticRenderFns } from "./142.vue?vue&type=template&id=c4e1a670&scoped=true&"
var script = {}
import style0 from "./142.vue?vue&type=style&index=0&id=c4e1a670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e1a670",
  null
  
)

export default component.exports